module.exports = __webpack_public_path__ + "img/44.9a868ce1.png";